import axios from 'axios'
import store from '../vuex/store'
import router from '../router/router'
import { createToaster } from "@meforma/vue-toaster";

const toast = createToaster(); // GLOBAL TOASTER

const apiClient = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
})

export async function post(url, data, config = {}) {
    const token = store.state.user?.accessToken

    if (token) {
        config.headers = {
            ...config.headers,
            Authorization: `Bearer ${token}`
        }
    }

    try {
        const response = await apiClient.post(url, data, config)

        if (response.status === 200 && response.data?.status === 'success') {
            return response;
        } 
        else if (response.status === 200 && response.data?.status === 'failure') {
            toast.error(response.data.message || "Request failed");
            router.push({ name: 'Home' });
        } 
        else {
            toast.error("Authentication expired. Please login again.");

            store.state.user.accessToken = ''
            store.state.isActiveToken = ''
            store.state.user.userInfo = ''
            localStorage.removeItem("userInfo")
            localStorage.removeItem("mDrivetoken")

            router.push({ name: 'Login' })

            return {
                success: false,
                data: response.data,
                message: response.data?.message || 'Something went wrong'
            }
        }

    } catch (error) {
        const msg = error.response?.data?.message || error.message || "Request failed";
        toast.error(msg);

        store.state.user.accessToken = ''
        store.state.isActiveToken = ''
        store.state.user.userInfo = ''
        localStorage.removeItem("userInfo")
        localStorage.removeItem("mDrivetoken")

        router.push({ name: 'Login' })

        return {
            success: false,
            error: true,
            message: msg
        }
    }
}

export async function postCommon(url, data, config = {}) {
    const token = store.state.user?.accessToken

    if (token) {
        config.headers = {
            ...config.headers,
            Authorization: `Bearer ${token}`
        }
    }

    try {
        const response = await apiClient.post(url, data, config)
        return response;
    } 
    catch (error) {
        const msg = error.response?.data?.message || error.message || "Request failed";
        toast.error(msg);
        throw error;
    }
}
